module.exports = __webpack_public_path__ + "static/media/la-brands-400.54b0b4e7.woff2";